module.exports = __webpack_public_path__ + "static/img/9.1.2dce66fa.png";